var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 31,
    fill: "#5EB5AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 22C32 21.4477 31.5523 21 31 21C30.4477 21 30 21.4477 30 22H31H32ZM30.2929 40.7071C30.6834 41.0976 31.3166 41.0976 31.7071 40.7071L38.0711 34.3431C38.4616 33.9526 38.4616 33.3195 38.0711 32.9289C37.6805 32.5384 37.0474 32.5384 36.6569 32.9289L31 38.5858L25.3431 32.9289C24.9526 32.5384 24.3195 32.5384 23.9289 32.9289C23.5384 33.3195 23.5384 33.9526 23.9289 34.3431L30.2929 40.7071ZM31 22H30V40H31H32V22H31Z",
    fill: "#F5F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.e5c4f350210481cbc98155e6001d9b60.svg";
export { ForwardRef as ReactComponent };